import React from 'react';
import logoText from '../../src/assets/svg/lawft-loading.svg';

export const SpinnerComponent = () => {
  return (
    <div className="spinner-container">
      <div id="loader">
        {/* <div id="box">
            <img className="logo-lawft" alt="logo" src={logo} />
          </div> */}
        <div className="logo">
          <img alt="lawft" src={logoText} />
        </div>
        <div id="shadow"></div>
      </div>
    </div>
  );
};
